import { create, enforce, group, omitWhen, only, test } from "vest"

import { StreamEvent } from "~types"

import {
  ValidationContext,
  ValidationSuite,
  ValidationSuiteFn
} from "../validation"

/** Company Synchronous Validation Suite */
export const streamEventSyncValidationSuite: ValidationSuite = create(
  "StreamEventSyncValidationSuite",
  (
    /** The object with data to validate */
    model: Partial<StreamEvent>,
    /** The property of that data to validate, if we only want to validate one property */
    field?: string,
    /** The group of properties in that data to validate, if we only want to validate one group */
    groupName?: string,
    /** Extra resources that a validator might need */
    context?: ValidationContext
  ) => {
    only(field) // if field defined, limit to tests of this field
    only.group(groupName) // if groupName defined, limit to tests of this group
    group("quiz", () =>
      streamEventSyncValidations(model, field, groupName, context)
    )
  }
)

/** Company Synchronous Validations, written in vest. */
export const streamEventSyncValidations: ValidationSuiteFn = (
  model: Partial<StreamEvent>
) => {
  model = model ?? {}
  // console.log("streamEventSyncValidations", model)

  test("gameName", "Game Name is required", () => {
    enforce(model.gameName).isNotBlank()
  })

  omitWhen(!model.gameName, () => {
    test("gameName", "Game Name must be at least 3 characters long", () => {
      enforce(model.gameName).longerThanOrEquals(3)
    })
  })
}
